import { api } from 'app/app.api';

import {
  ReadOriginalEmailApiArg,
  ReadOriginalEmailApiResponse,
  ReadScheduledConversationsCsvApiArg,
  ReadScheduledConversationsCsvApiResponse,
} from './types/userContentApi.types';
import { transformReadOriginalEmail } from './utils/transformResponse';

export const userContentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    readOriginalEmail: builder.query<
      ReadOriginalEmailApiResponse,
      ReadOriginalEmailApiArg
    >({
      query: ({ path }) => ({
        path,
        type: 'userContent',
      }),
      transformResponse: transformReadOriginalEmail,
    }),
    readScheduledConversationsCsv: builder.query<
      ReadScheduledConversationsCsvApiResponse,
      ReadScheduledConversationsCsvApiArg
    >({
      query: ({ path }) => ({
        path,
        type: 'userContent',
      }),
    }),
  }),
});
